import { useQuery } from '@tanstack/react-query'
import { ModuleConfigResponse, ModuleItemType, SectionsByModuleResponse } from '@/types/module'
import { axiosInstance } from '@/lib/axios'
import { AxiosError } from 'axios'
import BaseService from './baseService'

export const getModules = async () => {
  return axiosInstance.get<ModuleItemType[]>('/module/')
}

export const useGetModule = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['modules'],
    queryFn: getModules,
  })

  return {
    modules: data?.data,
    isLoadingModules: isLoading,
    refetchModules: refetch,
  }
}


class ModuleService extends BaseService {
  async getModules(): Promise<ModuleItemType[]> {
    try {
      const response = await this.get<ModuleItemType[]>('/module/')
      return response
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data) {
        throw new Error(
          error.response.data.message || 'Failed to fetch modules'
        )
      }
      throw error
    }
  }

  async getSectionsByModuleId(module_id: number): Promise<SectionsByModuleResponse> {
    try {
      const response = await this.get<SectionsByModuleResponse>(`/module/sections/${module_id}`)
      return response
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data) {
        throw new Error(error.response.data.message || 'Failed to fetch sections')
      }
      throw error
    }
  }

  async getModuleConfig(): Promise<ModuleConfigResponse> {
    try {
      const response = await this.get<ModuleConfigResponse>(`/module/config/`)
      return response
    }
    catch (error) {
      if (error instanceof AxiosError && error.response?.data) {
        throw new Error(error.response.data.message || 'Failed to fetch module config')
      }
      throw error
    }
  } 
}

export const moduleService = new ModuleService()
